/**
 * The room as a guest sees it: who they joined as, then the activity to
 * answer (GuestActivityRoom). One screen, used in two places:
 *   - at the room's own address, `/prioritization/sessions/:id/live`, for a
 *     guest who joined by link and is not signed in (roadmap S-8, ruling R1:
 *     members and guests answer at one address);
 *   - on the link's page, for someone signed in who joined by a guest link.
 * Every read and write goes through the token-scoped guest functions.
 */

import { Check } from 'lucide-react';
import type { GuestPass } from '@/lib/guestParticipant';
import { AppCard, Eyebrow } from '../components/primitives';
import GuestActivityRoom from './GuestActivityRoom';

export default function GuestRoomScreen({ pass }: { pass: GuestPass }) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50 pt-[env(safe-area-inset-top)] dark:bg-[var(--bg)]">
      <main className="mx-auto w-full max-w-md flex-1 px-4 py-10">
        <Eyebrow>Priorities.ai</Eyebrow>
        <AppCard className="mt-4">
          <div className="flex items-start gap-3">
            <Check className="mt-0.5 h-5 w-5 shrink-0 text-alpine-green-600" />
            <div>
              <h1 className="font-heading text-lg font-semibold text-gray-900 dark:text-[var(--text-pri)]">
                You&apos;re in, {pass.displayName}
              </h1>
              <p className="mt-1 font-body text-sm text-gray-600 dark:text-[var(--text-sec)]">
                You joined <span className="font-medium">{pass.sessionName}</span> — no account needed.
              </p>
            </div>
          </div>
        </AppCard>
        <GuestActivityRoom token={pass.token} guest={pass} />
      </main>
    </div>
  );
}
